/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ResetPasswordImport } from './routes/reset-password'
import { Route as RegisterImport } from './routes/register'
import { Route as LogoutImport } from './routes/logout'
import { Route as LoginImport } from './routes/login'
import { Route as AccessDeniedImport } from './routes/access-denied'
import { Route as AuthImport } from './routes/_auth'
import { Route as IndexImport } from './routes/index'
import { Route as SetPasswordTokenImport } from './routes/set-password.$token'
import { Route as AuthDevImport } from './routes/_auth/dev'
import { Route as AuthStatisticsIndexImport } from './routes/_auth/statistics/index'
import { Route as AuthRecordsIndexImport } from './routes/_auth/records/index'
import { Route as AuthGameSessionsIndexImport } from './routes/_auth/game-sessions/index'
import { Route as AuthGameSessionIndexImport } from './routes/_auth/game-session/index'
import { Route as AuthFriendsIndexImport } from './routes/_auth/friends/index'
import { Route as AuthDevIndexImport } from './routes/_auth/dev/index'
import { Route as AuthDashboardIndexImport } from './routes/_auth/dashboard/index'
import { Route as AuthGameSessionCreateImport } from './routes/_auth/game-session/create'
import { Route as AuthFriendsClaimImport } from './routes/_auth/friends/claim'
import { Route as AuthFriendsAddImport } from './routes/_auth/friends/add'
import { Route as AuthDevPresenterConfiguratorImport } from './routes/_auth/dev/presenter-configurator'
import { Route as AuthDevButtonsImport } from './routes/_auth/dev/buttons'
import { Route as AuthGameSessionGameSessionIdIndexImport } from './routes/_auth/game-session/$gameSessionId/index'
import { Route as AuthDevStatsIndexImport } from './routes/_auth/dev/stats/index'
import { Route as AuthDevScoreTakingIndexImport } from './routes/_auth/dev/score-taking/index'
import { Route as AuthDevPresenterIndexImport } from './routes/_auth/dev/presenter/index'
import { Route as AuthDashboardUserSettingsIndexImport } from './routes/_auth/dashboard/user-settings/index'
import { Route as AuthRecordsPlayerIdStatisticsImport } from './routes/_auth/records/$playerId/statistics'
import { Route as AuthFriendsTeamsCreateImport } from './routes/_auth/friends/teams/create'
import { Route as AuthFriendsPlayerIdStatisticsImport } from './routes/_auth/friends/$playerId/statistics'
import { Route as AuthDevStatsPreviewImport } from './routes/_auth/dev/stats/preview'
import { Route as AuthDevScoreTakingPreviewImport } from './routes/_auth/dev/score-taking/preview'
import { Route as AuthDevPresenterPreviewImport } from './routes/_auth/dev/presenter/preview'
import { Route as AuthDashboardUserSettingsDetailsImport } from './routes/_auth/dashboard/user-settings/details'
import { Route as AuthDashboardUserSettingsAvatarImport } from './routes/_auth/dashboard/user-settings/avatar'
import { Route as AuthGameSessionGameSessionIdScoreTakingIndexImport } from './routes/_auth/game-session/$gameSessionId/score-taking/index'
import { Route as AuthFriendsTeamsTeamIdIndexImport } from './routes/_auth/friends/teams/$teamId/index'
import { Route as AuthGameSessionGameSessionIdScoreTakingTiebreakWinImport } from './routes/_auth/game-session/$gameSessionId/score-taking/tiebreak-win'
import { Route as AuthGameSessionGameSessionIdScoreTakingSessionActionsImport } from './routes/_auth/game-session/$gameSessionId/score-taking/session-actions'
import { Route as AuthGameSessionGameSessionIdScoreTakingPresenterImport } from './routes/_auth/game-session/$gameSessionId/score-taking/presenter'
import { Route as AuthGameSessionGameSessionIdScoreTakingFinishImport } from './routes/_auth/game-session/$gameSessionId/score-taking/finish'
import { Route as AuthFriendsTeamsTeamIdEditImport } from './routes/_auth/friends/teams/$teamId/edit'
import { Route as AuthGameSessionGameSessionIdScoreTakingGamesCreateImport } from './routes/_auth/game-session/$gameSessionId/score-taking/games/create'
import { Route as AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsIndexImport } from './routes/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/index'
import { Route as AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsDeleteImport } from './routes/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete'

// Create/Update Routes

const ResetPasswordRoute = ResetPasswordImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const RegisterRoute = RegisterImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRoute,
} as any)

const LogoutRoute = LogoutImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const AccessDeniedRoute = AccessDeniedImport.update({
  id: '/access-denied',
  path: '/access-denied',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const SetPasswordTokenRoute = SetPasswordTokenImport.update({
  id: '/set-password/$token',
  path: '/set-password/$token',
  getParentRoute: () => rootRoute,
} as any)

const AuthDevRoute = AuthDevImport.update({
  id: '/dev',
  path: '/dev',
  getParentRoute: () => AuthRoute,
} as any)

const AuthStatisticsIndexRoute = AuthStatisticsIndexImport.update({
  id: '/statistics/',
  path: '/statistics/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthRecordsIndexRoute = AuthRecordsIndexImport.update({
  id: '/records/',
  path: '/records/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthGameSessionsIndexRoute = AuthGameSessionsIndexImport.update({
  id: '/game-sessions/',
  path: '/game-sessions/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthGameSessionIndexRoute = AuthGameSessionIndexImport.update({
  id: '/game-session/',
  path: '/game-session/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthFriendsIndexRoute = AuthFriendsIndexImport.update({
  id: '/friends/',
  path: '/friends/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthDevIndexRoute = AuthDevIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthDevRoute,
} as any)

const AuthDashboardIndexRoute = AuthDashboardIndexImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthGameSessionCreateRoute = AuthGameSessionCreateImport.update({
  id: '/game-session/create',
  path: '/game-session/create',
  getParentRoute: () => AuthRoute,
} as any)

const AuthFriendsClaimRoute = AuthFriendsClaimImport.update({
  id: '/friends/claim',
  path: '/friends/claim',
  getParentRoute: () => AuthRoute,
} as any)

const AuthFriendsAddRoute = AuthFriendsAddImport.update({
  id: '/friends/add',
  path: '/friends/add',
  getParentRoute: () => AuthRoute,
} as any)

const AuthDevPresenterConfiguratorRoute =
  AuthDevPresenterConfiguratorImport.update({
    id: '/presenter-configurator',
    path: '/presenter-configurator',
    getParentRoute: () => AuthDevRoute,
  } as any)

const AuthDevButtonsRoute = AuthDevButtonsImport.update({
  id: '/buttons',
  path: '/buttons',
  getParentRoute: () => AuthDevRoute,
} as any)

const AuthGameSessionGameSessionIdIndexRoute =
  AuthGameSessionGameSessionIdIndexImport.update({
    id: '/game-session/$gameSessionId/',
    path: '/game-session/$gameSessionId/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthDevStatsIndexRoute = AuthDevStatsIndexImport.update({
  id: '/stats/',
  path: '/stats/',
  getParentRoute: () => AuthDevRoute,
} as any)

const AuthDevScoreTakingIndexRoute = AuthDevScoreTakingIndexImport.update({
  id: '/score-taking/',
  path: '/score-taking/',
  getParentRoute: () => AuthDevRoute,
} as any)

const AuthDevPresenterIndexRoute = AuthDevPresenterIndexImport.update({
  id: '/presenter/',
  path: '/presenter/',
  getParentRoute: () => AuthDevRoute,
} as any)

const AuthDashboardUserSettingsIndexRoute =
  AuthDashboardUserSettingsIndexImport.update({
    id: '/dashboard/user-settings/',
    path: '/dashboard/user-settings/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthRecordsPlayerIdStatisticsRoute =
  AuthRecordsPlayerIdStatisticsImport.update({
    id: '/records/$playerId/statistics',
    path: '/records/$playerId/statistics',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthFriendsTeamsCreateRoute = AuthFriendsTeamsCreateImport.update({
  id: '/friends/teams/create',
  path: '/friends/teams/create',
  getParentRoute: () => AuthRoute,
} as any)

const AuthFriendsPlayerIdStatisticsRoute =
  AuthFriendsPlayerIdStatisticsImport.update({
    id: '/friends/$playerId/statistics',
    path: '/friends/$playerId/statistics',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthDevStatsPreviewRoute = AuthDevStatsPreviewImport.update({
  id: '/stats/preview',
  path: '/stats/preview',
  getParentRoute: () => AuthDevRoute,
} as any)

const AuthDevScoreTakingPreviewRoute = AuthDevScoreTakingPreviewImport.update({
  id: '/score-taking/preview',
  path: '/score-taking/preview',
  getParentRoute: () => AuthDevRoute,
} as any)

const AuthDevPresenterPreviewRoute = AuthDevPresenterPreviewImport.update({
  id: '/presenter/preview',
  path: '/presenter/preview',
  getParentRoute: () => AuthDevRoute,
} as any)

const AuthDashboardUserSettingsDetailsRoute =
  AuthDashboardUserSettingsDetailsImport.update({
    id: '/dashboard/user-settings/details',
    path: '/dashboard/user-settings/details',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthDashboardUserSettingsAvatarRoute =
  AuthDashboardUserSettingsAvatarImport.update({
    id: '/dashboard/user-settings/avatar',
    path: '/dashboard/user-settings/avatar',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthGameSessionGameSessionIdScoreTakingIndexRoute =
  AuthGameSessionGameSessionIdScoreTakingIndexImport.update({
    id: '/game-session/$gameSessionId/score-taking/',
    path: '/game-session/$gameSessionId/score-taking/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthFriendsTeamsTeamIdIndexRoute =
  AuthFriendsTeamsTeamIdIndexImport.update({
    id: '/friends/teams/$teamId/',
    path: '/friends/teams/$teamId/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthGameSessionGameSessionIdScoreTakingTiebreakWinRoute =
  AuthGameSessionGameSessionIdScoreTakingTiebreakWinImport.update({
    id: '/game-session/$gameSessionId/score-taking/tiebreak-win',
    path: '/game-session/$gameSessionId/score-taking/tiebreak-win',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthGameSessionGameSessionIdScoreTakingSessionActionsRoute =
  AuthGameSessionGameSessionIdScoreTakingSessionActionsImport.update({
    id: '/game-session/$gameSessionId/score-taking/session-actions',
    path: '/game-session/$gameSessionId/score-taking/session-actions',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthGameSessionGameSessionIdScoreTakingPresenterRoute =
  AuthGameSessionGameSessionIdScoreTakingPresenterImport.update({
    id: '/game-session/$gameSessionId/score-taking/presenter',
    path: '/game-session/$gameSessionId/score-taking/presenter',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthGameSessionGameSessionIdScoreTakingFinishRoute =
  AuthGameSessionGameSessionIdScoreTakingFinishImport.update({
    id: '/game-session/$gameSessionId/score-taking/finish',
    path: '/game-session/$gameSessionId/score-taking/finish',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthFriendsTeamsTeamIdEditRoute = AuthFriendsTeamsTeamIdEditImport.update(
  {
    id: '/friends/teams/$teamId/edit',
    path: '/friends/teams/$teamId/edit',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthGameSessionGameSessionIdScoreTakingGamesCreateRoute =
  AuthGameSessionGameSessionIdScoreTakingGamesCreateImport.update({
    id: '/game-session/$gameSessionId/score-taking/games/create',
    path: '/game-session/$gameSessionId/score-taking/games/create',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsIndexRoute =
  AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsIndexImport.update({
    id: '/game-session/$gameSessionId/score-taking/games/$gameId/rounds/',
    path: '/game-session/$gameSessionId/score-taking/games/$gameId/rounds/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsDeleteRoute =
  AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsDeleteImport.update({
    id: '/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete',
    path: '/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete',
    getParentRoute: () => AuthRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/access-denied': {
      id: '/access-denied'
      path: '/access-denied'
      fullPath: '/access-denied'
      preLoaderRoute: typeof AccessDeniedImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutImport
      parentRoute: typeof rootRoute
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterImport
      parentRoute: typeof rootRoute
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/_auth/dev': {
      id: '/_auth/dev'
      path: '/dev'
      fullPath: '/dev'
      preLoaderRoute: typeof AuthDevImport
      parentRoute: typeof AuthImport
    }
    '/set-password/$token': {
      id: '/set-password/$token'
      path: '/set-password/$token'
      fullPath: '/set-password/$token'
      preLoaderRoute: typeof SetPasswordTokenImport
      parentRoute: typeof rootRoute
    }
    '/_auth/dev/buttons': {
      id: '/_auth/dev/buttons'
      path: '/buttons'
      fullPath: '/dev/buttons'
      preLoaderRoute: typeof AuthDevButtonsImport
      parentRoute: typeof AuthDevImport
    }
    '/_auth/dev/presenter-configurator': {
      id: '/_auth/dev/presenter-configurator'
      path: '/presenter-configurator'
      fullPath: '/dev/presenter-configurator'
      preLoaderRoute: typeof AuthDevPresenterConfiguratorImport
      parentRoute: typeof AuthDevImport
    }
    '/_auth/friends/add': {
      id: '/_auth/friends/add'
      path: '/friends/add'
      fullPath: '/friends/add'
      preLoaderRoute: typeof AuthFriendsAddImport
      parentRoute: typeof AuthImport
    }
    '/_auth/friends/claim': {
      id: '/_auth/friends/claim'
      path: '/friends/claim'
      fullPath: '/friends/claim'
      preLoaderRoute: typeof AuthFriendsClaimImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-session/create': {
      id: '/_auth/game-session/create'
      path: '/game-session/create'
      fullPath: '/game-session/create'
      preLoaderRoute: typeof AuthGameSessionCreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/dashboard/': {
      id: '/_auth/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/dev/': {
      id: '/_auth/dev/'
      path: '/'
      fullPath: '/dev/'
      preLoaderRoute: typeof AuthDevIndexImport
      parentRoute: typeof AuthDevImport
    }
    '/_auth/friends/': {
      id: '/_auth/friends/'
      path: '/friends'
      fullPath: '/friends'
      preLoaderRoute: typeof AuthFriendsIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-session/': {
      id: '/_auth/game-session/'
      path: '/game-session'
      fullPath: '/game-session'
      preLoaderRoute: typeof AuthGameSessionIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-sessions/': {
      id: '/_auth/game-sessions/'
      path: '/game-sessions'
      fullPath: '/game-sessions'
      preLoaderRoute: typeof AuthGameSessionsIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/records/': {
      id: '/_auth/records/'
      path: '/records'
      fullPath: '/records'
      preLoaderRoute: typeof AuthRecordsIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/statistics/': {
      id: '/_auth/statistics/'
      path: '/statistics'
      fullPath: '/statistics'
      preLoaderRoute: typeof AuthStatisticsIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/dashboard/user-settings/avatar': {
      id: '/_auth/dashboard/user-settings/avatar'
      path: '/dashboard/user-settings/avatar'
      fullPath: '/dashboard/user-settings/avatar'
      preLoaderRoute: typeof AuthDashboardUserSettingsAvatarImport
      parentRoute: typeof AuthImport
    }
    '/_auth/dashboard/user-settings/details': {
      id: '/_auth/dashboard/user-settings/details'
      path: '/dashboard/user-settings/details'
      fullPath: '/dashboard/user-settings/details'
      preLoaderRoute: typeof AuthDashboardUserSettingsDetailsImport
      parentRoute: typeof AuthImport
    }
    '/_auth/dev/presenter/preview': {
      id: '/_auth/dev/presenter/preview'
      path: '/presenter/preview'
      fullPath: '/dev/presenter/preview'
      preLoaderRoute: typeof AuthDevPresenterPreviewImport
      parentRoute: typeof AuthDevImport
    }
    '/_auth/dev/score-taking/preview': {
      id: '/_auth/dev/score-taking/preview'
      path: '/score-taking/preview'
      fullPath: '/dev/score-taking/preview'
      preLoaderRoute: typeof AuthDevScoreTakingPreviewImport
      parentRoute: typeof AuthDevImport
    }
    '/_auth/dev/stats/preview': {
      id: '/_auth/dev/stats/preview'
      path: '/stats/preview'
      fullPath: '/dev/stats/preview'
      preLoaderRoute: typeof AuthDevStatsPreviewImport
      parentRoute: typeof AuthDevImport
    }
    '/_auth/friends/$playerId/statistics': {
      id: '/_auth/friends/$playerId/statistics'
      path: '/friends/$playerId/statistics'
      fullPath: '/friends/$playerId/statistics'
      preLoaderRoute: typeof AuthFriendsPlayerIdStatisticsImport
      parentRoute: typeof AuthImport
    }
    '/_auth/friends/teams/create': {
      id: '/_auth/friends/teams/create'
      path: '/friends/teams/create'
      fullPath: '/friends/teams/create'
      preLoaderRoute: typeof AuthFriendsTeamsCreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/records/$playerId/statistics': {
      id: '/_auth/records/$playerId/statistics'
      path: '/records/$playerId/statistics'
      fullPath: '/records/$playerId/statistics'
      preLoaderRoute: typeof AuthRecordsPlayerIdStatisticsImport
      parentRoute: typeof AuthImport
    }
    '/_auth/dashboard/user-settings/': {
      id: '/_auth/dashboard/user-settings/'
      path: '/dashboard/user-settings'
      fullPath: '/dashboard/user-settings'
      preLoaderRoute: typeof AuthDashboardUserSettingsIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/dev/presenter/': {
      id: '/_auth/dev/presenter/'
      path: '/presenter'
      fullPath: '/dev/presenter'
      preLoaderRoute: typeof AuthDevPresenterIndexImport
      parentRoute: typeof AuthDevImport
    }
    '/_auth/dev/score-taking/': {
      id: '/_auth/dev/score-taking/'
      path: '/score-taking'
      fullPath: '/dev/score-taking'
      preLoaderRoute: typeof AuthDevScoreTakingIndexImport
      parentRoute: typeof AuthDevImport
    }
    '/_auth/dev/stats/': {
      id: '/_auth/dev/stats/'
      path: '/stats'
      fullPath: '/dev/stats'
      preLoaderRoute: typeof AuthDevStatsIndexImport
      parentRoute: typeof AuthDevImport
    }
    '/_auth/game-session/$gameSessionId/': {
      id: '/_auth/game-session/$gameSessionId/'
      path: '/game-session/$gameSessionId'
      fullPath: '/game-session/$gameSessionId'
      preLoaderRoute: typeof AuthGameSessionGameSessionIdIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/friends/teams/$teamId/edit': {
      id: '/_auth/friends/teams/$teamId/edit'
      path: '/friends/teams/$teamId/edit'
      fullPath: '/friends/teams/$teamId/edit'
      preLoaderRoute: typeof AuthFriendsTeamsTeamIdEditImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-session/$gameSessionId/score-taking/finish': {
      id: '/_auth/game-session/$gameSessionId/score-taking/finish'
      path: '/game-session/$gameSessionId/score-taking/finish'
      fullPath: '/game-session/$gameSessionId/score-taking/finish'
      preLoaderRoute: typeof AuthGameSessionGameSessionIdScoreTakingFinishImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-session/$gameSessionId/score-taking/presenter': {
      id: '/_auth/game-session/$gameSessionId/score-taking/presenter'
      path: '/game-session/$gameSessionId/score-taking/presenter'
      fullPath: '/game-session/$gameSessionId/score-taking/presenter'
      preLoaderRoute: typeof AuthGameSessionGameSessionIdScoreTakingPresenterImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-session/$gameSessionId/score-taking/session-actions': {
      id: '/_auth/game-session/$gameSessionId/score-taking/session-actions'
      path: '/game-session/$gameSessionId/score-taking/session-actions'
      fullPath: '/game-session/$gameSessionId/score-taking/session-actions'
      preLoaderRoute: typeof AuthGameSessionGameSessionIdScoreTakingSessionActionsImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-session/$gameSessionId/score-taking/tiebreak-win': {
      id: '/_auth/game-session/$gameSessionId/score-taking/tiebreak-win'
      path: '/game-session/$gameSessionId/score-taking/tiebreak-win'
      fullPath: '/game-session/$gameSessionId/score-taking/tiebreak-win'
      preLoaderRoute: typeof AuthGameSessionGameSessionIdScoreTakingTiebreakWinImport
      parentRoute: typeof AuthImport
    }
    '/_auth/friends/teams/$teamId/': {
      id: '/_auth/friends/teams/$teamId/'
      path: '/friends/teams/$teamId'
      fullPath: '/friends/teams/$teamId'
      preLoaderRoute: typeof AuthFriendsTeamsTeamIdIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-session/$gameSessionId/score-taking/': {
      id: '/_auth/game-session/$gameSessionId/score-taking/'
      path: '/game-session/$gameSessionId/score-taking'
      fullPath: '/game-session/$gameSessionId/score-taking'
      preLoaderRoute: typeof AuthGameSessionGameSessionIdScoreTakingIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-session/$gameSessionId/score-taking/games/create': {
      id: '/_auth/game-session/$gameSessionId/score-taking/games/create'
      path: '/game-session/$gameSessionId/score-taking/games/create'
      fullPath: '/game-session/$gameSessionId/score-taking/games/create'
      preLoaderRoute: typeof AuthGameSessionGameSessionIdScoreTakingGamesCreateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete': {
      id: '/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete'
      path: '/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete'
      fullPath: '/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete'
      preLoaderRoute: typeof AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsDeleteImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/': {
      id: '/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/'
      path: '/game-session/$gameSessionId/score-taking/games/$gameId/rounds'
      fullPath: '/game-session/$gameSessionId/score-taking/games/$gameId/rounds'
      preLoaderRoute: typeof AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsIndexImport
      parentRoute: typeof AuthImport
    }
  }
}

// Create and export the route tree

interface AuthDevRouteChildren {
  AuthDevButtonsRoute: typeof AuthDevButtonsRoute
  AuthDevPresenterConfiguratorRoute: typeof AuthDevPresenterConfiguratorRoute
  AuthDevIndexRoute: typeof AuthDevIndexRoute
  AuthDevPresenterPreviewRoute: typeof AuthDevPresenterPreviewRoute
  AuthDevScoreTakingPreviewRoute: typeof AuthDevScoreTakingPreviewRoute
  AuthDevStatsPreviewRoute: typeof AuthDevStatsPreviewRoute
  AuthDevPresenterIndexRoute: typeof AuthDevPresenterIndexRoute
  AuthDevScoreTakingIndexRoute: typeof AuthDevScoreTakingIndexRoute
  AuthDevStatsIndexRoute: typeof AuthDevStatsIndexRoute
}

const AuthDevRouteChildren: AuthDevRouteChildren = {
  AuthDevButtonsRoute: AuthDevButtonsRoute,
  AuthDevPresenterConfiguratorRoute: AuthDevPresenterConfiguratorRoute,
  AuthDevIndexRoute: AuthDevIndexRoute,
  AuthDevPresenterPreviewRoute: AuthDevPresenterPreviewRoute,
  AuthDevScoreTakingPreviewRoute: AuthDevScoreTakingPreviewRoute,
  AuthDevStatsPreviewRoute: AuthDevStatsPreviewRoute,
  AuthDevPresenterIndexRoute: AuthDevPresenterIndexRoute,
  AuthDevScoreTakingIndexRoute: AuthDevScoreTakingIndexRoute,
  AuthDevStatsIndexRoute: AuthDevStatsIndexRoute,
}

const AuthDevRouteWithChildren =
  AuthDevRoute._addFileChildren(AuthDevRouteChildren)

interface AuthRouteChildren {
  AuthDevRoute: typeof AuthDevRouteWithChildren
  AuthFriendsAddRoute: typeof AuthFriendsAddRoute
  AuthFriendsClaimRoute: typeof AuthFriendsClaimRoute
  AuthGameSessionCreateRoute: typeof AuthGameSessionCreateRoute
  AuthDashboardIndexRoute: typeof AuthDashboardIndexRoute
  AuthFriendsIndexRoute: typeof AuthFriendsIndexRoute
  AuthGameSessionIndexRoute: typeof AuthGameSessionIndexRoute
  AuthGameSessionsIndexRoute: typeof AuthGameSessionsIndexRoute
  AuthRecordsIndexRoute: typeof AuthRecordsIndexRoute
  AuthStatisticsIndexRoute: typeof AuthStatisticsIndexRoute
  AuthDashboardUserSettingsAvatarRoute: typeof AuthDashboardUserSettingsAvatarRoute
  AuthDashboardUserSettingsDetailsRoute: typeof AuthDashboardUserSettingsDetailsRoute
  AuthFriendsPlayerIdStatisticsRoute: typeof AuthFriendsPlayerIdStatisticsRoute
  AuthFriendsTeamsCreateRoute: typeof AuthFriendsTeamsCreateRoute
  AuthRecordsPlayerIdStatisticsRoute: typeof AuthRecordsPlayerIdStatisticsRoute
  AuthDashboardUserSettingsIndexRoute: typeof AuthDashboardUserSettingsIndexRoute
  AuthGameSessionGameSessionIdIndexRoute: typeof AuthGameSessionGameSessionIdIndexRoute
  AuthFriendsTeamsTeamIdEditRoute: typeof AuthFriendsTeamsTeamIdEditRoute
  AuthGameSessionGameSessionIdScoreTakingFinishRoute: typeof AuthGameSessionGameSessionIdScoreTakingFinishRoute
  AuthGameSessionGameSessionIdScoreTakingPresenterRoute: typeof AuthGameSessionGameSessionIdScoreTakingPresenterRoute
  AuthGameSessionGameSessionIdScoreTakingSessionActionsRoute: typeof AuthGameSessionGameSessionIdScoreTakingSessionActionsRoute
  AuthGameSessionGameSessionIdScoreTakingTiebreakWinRoute: typeof AuthGameSessionGameSessionIdScoreTakingTiebreakWinRoute
  AuthFriendsTeamsTeamIdIndexRoute: typeof AuthFriendsTeamsTeamIdIndexRoute
  AuthGameSessionGameSessionIdScoreTakingIndexRoute: typeof AuthGameSessionGameSessionIdScoreTakingIndexRoute
  AuthGameSessionGameSessionIdScoreTakingGamesCreateRoute: typeof AuthGameSessionGameSessionIdScoreTakingGamesCreateRoute
  AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsDeleteRoute: typeof AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsDeleteRoute
  AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsIndexRoute: typeof AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthDevRoute: AuthDevRouteWithChildren,
  AuthFriendsAddRoute: AuthFriendsAddRoute,
  AuthFriendsClaimRoute: AuthFriendsClaimRoute,
  AuthGameSessionCreateRoute: AuthGameSessionCreateRoute,
  AuthDashboardIndexRoute: AuthDashboardIndexRoute,
  AuthFriendsIndexRoute: AuthFriendsIndexRoute,
  AuthGameSessionIndexRoute: AuthGameSessionIndexRoute,
  AuthGameSessionsIndexRoute: AuthGameSessionsIndexRoute,
  AuthRecordsIndexRoute: AuthRecordsIndexRoute,
  AuthStatisticsIndexRoute: AuthStatisticsIndexRoute,
  AuthDashboardUserSettingsAvatarRoute: AuthDashboardUserSettingsAvatarRoute,
  AuthDashboardUserSettingsDetailsRoute: AuthDashboardUserSettingsDetailsRoute,
  AuthFriendsPlayerIdStatisticsRoute: AuthFriendsPlayerIdStatisticsRoute,
  AuthFriendsTeamsCreateRoute: AuthFriendsTeamsCreateRoute,
  AuthRecordsPlayerIdStatisticsRoute: AuthRecordsPlayerIdStatisticsRoute,
  AuthDashboardUserSettingsIndexRoute: AuthDashboardUserSettingsIndexRoute,
  AuthGameSessionGameSessionIdIndexRoute:
    AuthGameSessionGameSessionIdIndexRoute,
  AuthFriendsTeamsTeamIdEditRoute: AuthFriendsTeamsTeamIdEditRoute,
  AuthGameSessionGameSessionIdScoreTakingFinishRoute:
    AuthGameSessionGameSessionIdScoreTakingFinishRoute,
  AuthGameSessionGameSessionIdScoreTakingPresenterRoute:
    AuthGameSessionGameSessionIdScoreTakingPresenterRoute,
  AuthGameSessionGameSessionIdScoreTakingSessionActionsRoute:
    AuthGameSessionGameSessionIdScoreTakingSessionActionsRoute,
  AuthGameSessionGameSessionIdScoreTakingTiebreakWinRoute:
    AuthGameSessionGameSessionIdScoreTakingTiebreakWinRoute,
  AuthFriendsTeamsTeamIdIndexRoute: AuthFriendsTeamsTeamIdIndexRoute,
  AuthGameSessionGameSessionIdScoreTakingIndexRoute:
    AuthGameSessionGameSessionIdScoreTakingIndexRoute,
  AuthGameSessionGameSessionIdScoreTakingGamesCreateRoute:
    AuthGameSessionGameSessionIdScoreTakingGamesCreateRoute,
  AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsDeleteRoute:
    AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsDeleteRoute,
  AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsIndexRoute:
    AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof AuthRouteWithChildren
  '/access-denied': typeof AccessDeniedRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/dev': typeof AuthDevRouteWithChildren
  '/set-password/$token': typeof SetPasswordTokenRoute
  '/dev/buttons': typeof AuthDevButtonsRoute
  '/dev/presenter-configurator': typeof AuthDevPresenterConfiguratorRoute
  '/friends/add': typeof AuthFriendsAddRoute
  '/friends/claim': typeof AuthFriendsClaimRoute
  '/game-session/create': typeof AuthGameSessionCreateRoute
  '/dashboard': typeof AuthDashboardIndexRoute
  '/dev/': typeof AuthDevIndexRoute
  '/friends': typeof AuthFriendsIndexRoute
  '/game-session': typeof AuthGameSessionIndexRoute
  '/game-sessions': typeof AuthGameSessionsIndexRoute
  '/records': typeof AuthRecordsIndexRoute
  '/statistics': typeof AuthStatisticsIndexRoute
  '/dashboard/user-settings/avatar': typeof AuthDashboardUserSettingsAvatarRoute
  '/dashboard/user-settings/details': typeof AuthDashboardUserSettingsDetailsRoute
  '/dev/presenter/preview': typeof AuthDevPresenterPreviewRoute
  '/dev/score-taking/preview': typeof AuthDevScoreTakingPreviewRoute
  '/dev/stats/preview': typeof AuthDevStatsPreviewRoute
  '/friends/$playerId/statistics': typeof AuthFriendsPlayerIdStatisticsRoute
  '/friends/teams/create': typeof AuthFriendsTeamsCreateRoute
  '/records/$playerId/statistics': typeof AuthRecordsPlayerIdStatisticsRoute
  '/dashboard/user-settings': typeof AuthDashboardUserSettingsIndexRoute
  '/dev/presenter': typeof AuthDevPresenterIndexRoute
  '/dev/score-taking': typeof AuthDevScoreTakingIndexRoute
  '/dev/stats': typeof AuthDevStatsIndexRoute
  '/game-session/$gameSessionId': typeof AuthGameSessionGameSessionIdIndexRoute
  '/friends/teams/$teamId/edit': typeof AuthFriendsTeamsTeamIdEditRoute
  '/game-session/$gameSessionId/score-taking/finish': typeof AuthGameSessionGameSessionIdScoreTakingFinishRoute
  '/game-session/$gameSessionId/score-taking/presenter': typeof AuthGameSessionGameSessionIdScoreTakingPresenterRoute
  '/game-session/$gameSessionId/score-taking/session-actions': typeof AuthGameSessionGameSessionIdScoreTakingSessionActionsRoute
  '/game-session/$gameSessionId/score-taking/tiebreak-win': typeof AuthGameSessionGameSessionIdScoreTakingTiebreakWinRoute
  '/friends/teams/$teamId': typeof AuthFriendsTeamsTeamIdIndexRoute
  '/game-session/$gameSessionId/score-taking': typeof AuthGameSessionGameSessionIdScoreTakingIndexRoute
  '/game-session/$gameSessionId/score-taking/games/create': typeof AuthGameSessionGameSessionIdScoreTakingGamesCreateRoute
  '/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete': typeof AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsDeleteRoute
  '/game-session/$gameSessionId/score-taking/games/$gameId/rounds': typeof AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof AuthRouteWithChildren
  '/access-denied': typeof AccessDeniedRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/set-password/$token': typeof SetPasswordTokenRoute
  '/dev/buttons': typeof AuthDevButtonsRoute
  '/dev/presenter-configurator': typeof AuthDevPresenterConfiguratorRoute
  '/friends/add': typeof AuthFriendsAddRoute
  '/friends/claim': typeof AuthFriendsClaimRoute
  '/game-session/create': typeof AuthGameSessionCreateRoute
  '/dashboard': typeof AuthDashboardIndexRoute
  '/dev': typeof AuthDevIndexRoute
  '/friends': typeof AuthFriendsIndexRoute
  '/game-session': typeof AuthGameSessionIndexRoute
  '/game-sessions': typeof AuthGameSessionsIndexRoute
  '/records': typeof AuthRecordsIndexRoute
  '/statistics': typeof AuthStatisticsIndexRoute
  '/dashboard/user-settings/avatar': typeof AuthDashboardUserSettingsAvatarRoute
  '/dashboard/user-settings/details': typeof AuthDashboardUserSettingsDetailsRoute
  '/dev/presenter/preview': typeof AuthDevPresenterPreviewRoute
  '/dev/score-taking/preview': typeof AuthDevScoreTakingPreviewRoute
  '/dev/stats/preview': typeof AuthDevStatsPreviewRoute
  '/friends/$playerId/statistics': typeof AuthFriendsPlayerIdStatisticsRoute
  '/friends/teams/create': typeof AuthFriendsTeamsCreateRoute
  '/records/$playerId/statistics': typeof AuthRecordsPlayerIdStatisticsRoute
  '/dashboard/user-settings': typeof AuthDashboardUserSettingsIndexRoute
  '/dev/presenter': typeof AuthDevPresenterIndexRoute
  '/dev/score-taking': typeof AuthDevScoreTakingIndexRoute
  '/dev/stats': typeof AuthDevStatsIndexRoute
  '/game-session/$gameSessionId': typeof AuthGameSessionGameSessionIdIndexRoute
  '/friends/teams/$teamId/edit': typeof AuthFriendsTeamsTeamIdEditRoute
  '/game-session/$gameSessionId/score-taking/finish': typeof AuthGameSessionGameSessionIdScoreTakingFinishRoute
  '/game-session/$gameSessionId/score-taking/presenter': typeof AuthGameSessionGameSessionIdScoreTakingPresenterRoute
  '/game-session/$gameSessionId/score-taking/session-actions': typeof AuthGameSessionGameSessionIdScoreTakingSessionActionsRoute
  '/game-session/$gameSessionId/score-taking/tiebreak-win': typeof AuthGameSessionGameSessionIdScoreTakingTiebreakWinRoute
  '/friends/teams/$teamId': typeof AuthFriendsTeamsTeamIdIndexRoute
  '/game-session/$gameSessionId/score-taking': typeof AuthGameSessionGameSessionIdScoreTakingIndexRoute
  '/game-session/$gameSessionId/score-taking/games/create': typeof AuthGameSessionGameSessionIdScoreTakingGamesCreateRoute
  '/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete': typeof AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsDeleteRoute
  '/game-session/$gameSessionId/score-taking/games/$gameId/rounds': typeof AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/access-denied': typeof AccessDeniedRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_auth/dev': typeof AuthDevRouteWithChildren
  '/set-password/$token': typeof SetPasswordTokenRoute
  '/_auth/dev/buttons': typeof AuthDevButtonsRoute
  '/_auth/dev/presenter-configurator': typeof AuthDevPresenterConfiguratorRoute
  '/_auth/friends/add': typeof AuthFriendsAddRoute
  '/_auth/friends/claim': typeof AuthFriendsClaimRoute
  '/_auth/game-session/create': typeof AuthGameSessionCreateRoute
  '/_auth/dashboard/': typeof AuthDashboardIndexRoute
  '/_auth/dev/': typeof AuthDevIndexRoute
  '/_auth/friends/': typeof AuthFriendsIndexRoute
  '/_auth/game-session/': typeof AuthGameSessionIndexRoute
  '/_auth/game-sessions/': typeof AuthGameSessionsIndexRoute
  '/_auth/records/': typeof AuthRecordsIndexRoute
  '/_auth/statistics/': typeof AuthStatisticsIndexRoute
  '/_auth/dashboard/user-settings/avatar': typeof AuthDashboardUserSettingsAvatarRoute
  '/_auth/dashboard/user-settings/details': typeof AuthDashboardUserSettingsDetailsRoute
  '/_auth/dev/presenter/preview': typeof AuthDevPresenterPreviewRoute
  '/_auth/dev/score-taking/preview': typeof AuthDevScoreTakingPreviewRoute
  '/_auth/dev/stats/preview': typeof AuthDevStatsPreviewRoute
  '/_auth/friends/$playerId/statistics': typeof AuthFriendsPlayerIdStatisticsRoute
  '/_auth/friends/teams/create': typeof AuthFriendsTeamsCreateRoute
  '/_auth/records/$playerId/statistics': typeof AuthRecordsPlayerIdStatisticsRoute
  '/_auth/dashboard/user-settings/': typeof AuthDashboardUserSettingsIndexRoute
  '/_auth/dev/presenter/': typeof AuthDevPresenterIndexRoute
  '/_auth/dev/score-taking/': typeof AuthDevScoreTakingIndexRoute
  '/_auth/dev/stats/': typeof AuthDevStatsIndexRoute
  '/_auth/game-session/$gameSessionId/': typeof AuthGameSessionGameSessionIdIndexRoute
  '/_auth/friends/teams/$teamId/edit': typeof AuthFriendsTeamsTeamIdEditRoute
  '/_auth/game-session/$gameSessionId/score-taking/finish': typeof AuthGameSessionGameSessionIdScoreTakingFinishRoute
  '/_auth/game-session/$gameSessionId/score-taking/presenter': typeof AuthGameSessionGameSessionIdScoreTakingPresenterRoute
  '/_auth/game-session/$gameSessionId/score-taking/session-actions': typeof AuthGameSessionGameSessionIdScoreTakingSessionActionsRoute
  '/_auth/game-session/$gameSessionId/score-taking/tiebreak-win': typeof AuthGameSessionGameSessionIdScoreTakingTiebreakWinRoute
  '/_auth/friends/teams/$teamId/': typeof AuthFriendsTeamsTeamIdIndexRoute
  '/_auth/game-session/$gameSessionId/score-taking/': typeof AuthGameSessionGameSessionIdScoreTakingIndexRoute
  '/_auth/game-session/$gameSessionId/score-taking/games/create': typeof AuthGameSessionGameSessionIdScoreTakingGamesCreateRoute
  '/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete': typeof AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsDeleteRoute
  '/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/': typeof AuthGameSessionGameSessionIdScoreTakingGamesGameIdRoundsIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/access-denied'
    | '/login'
    | '/logout'
    | '/register'
    | '/reset-password'
    | '/dev'
    | '/set-password/$token'
    | '/dev/buttons'
    | '/dev/presenter-configurator'
    | '/friends/add'
    | '/friends/claim'
    | '/game-session/create'
    | '/dashboard'
    | '/dev/'
    | '/friends'
    | '/game-session'
    | '/game-sessions'
    | '/records'
    | '/statistics'
    | '/dashboard/user-settings/avatar'
    | '/dashboard/user-settings/details'
    | '/dev/presenter/preview'
    | '/dev/score-taking/preview'
    | '/dev/stats/preview'
    | '/friends/$playerId/statistics'
    | '/friends/teams/create'
    | '/records/$playerId/statistics'
    | '/dashboard/user-settings'
    | '/dev/presenter'
    | '/dev/score-taking'
    | '/dev/stats'
    | '/game-session/$gameSessionId'
    | '/friends/teams/$teamId/edit'
    | '/game-session/$gameSessionId/score-taking/finish'
    | '/game-session/$gameSessionId/score-taking/presenter'
    | '/game-session/$gameSessionId/score-taking/session-actions'
    | '/game-session/$gameSessionId/score-taking/tiebreak-win'
    | '/friends/teams/$teamId'
    | '/game-session/$gameSessionId/score-taking'
    | '/game-session/$gameSessionId/score-taking/games/create'
    | '/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete'
    | '/game-session/$gameSessionId/score-taking/games/$gameId/rounds'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/access-denied'
    | '/login'
    | '/logout'
    | '/register'
    | '/reset-password'
    | '/set-password/$token'
    | '/dev/buttons'
    | '/dev/presenter-configurator'
    | '/friends/add'
    | '/friends/claim'
    | '/game-session/create'
    | '/dashboard'
    | '/dev'
    | '/friends'
    | '/game-session'
    | '/game-sessions'
    | '/records'
    | '/statistics'
    | '/dashboard/user-settings/avatar'
    | '/dashboard/user-settings/details'
    | '/dev/presenter/preview'
    | '/dev/score-taking/preview'
    | '/dev/stats/preview'
    | '/friends/$playerId/statistics'
    | '/friends/teams/create'
    | '/records/$playerId/statistics'
    | '/dashboard/user-settings'
    | '/dev/presenter'
    | '/dev/score-taking'
    | '/dev/stats'
    | '/game-session/$gameSessionId'
    | '/friends/teams/$teamId/edit'
    | '/game-session/$gameSessionId/score-taking/finish'
    | '/game-session/$gameSessionId/score-taking/presenter'
    | '/game-session/$gameSessionId/score-taking/session-actions'
    | '/game-session/$gameSessionId/score-taking/tiebreak-win'
    | '/friends/teams/$teamId'
    | '/game-session/$gameSessionId/score-taking'
    | '/game-session/$gameSessionId/score-taking/games/create'
    | '/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete'
    | '/game-session/$gameSessionId/score-taking/games/$gameId/rounds'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/access-denied'
    | '/login'
    | '/logout'
    | '/register'
    | '/reset-password'
    | '/_auth/dev'
    | '/set-password/$token'
    | '/_auth/dev/buttons'
    | '/_auth/dev/presenter-configurator'
    | '/_auth/friends/add'
    | '/_auth/friends/claim'
    | '/_auth/game-session/create'
    | '/_auth/dashboard/'
    | '/_auth/dev/'
    | '/_auth/friends/'
    | '/_auth/game-session/'
    | '/_auth/game-sessions/'
    | '/_auth/records/'
    | '/_auth/statistics/'
    | '/_auth/dashboard/user-settings/avatar'
    | '/_auth/dashboard/user-settings/details'
    | '/_auth/dev/presenter/preview'
    | '/_auth/dev/score-taking/preview'
    | '/_auth/dev/stats/preview'
    | '/_auth/friends/$playerId/statistics'
    | '/_auth/friends/teams/create'
    | '/_auth/records/$playerId/statistics'
    | '/_auth/dashboard/user-settings/'
    | '/_auth/dev/presenter/'
    | '/_auth/dev/score-taking/'
    | '/_auth/dev/stats/'
    | '/_auth/game-session/$gameSessionId/'
    | '/_auth/friends/teams/$teamId/edit'
    | '/_auth/game-session/$gameSessionId/score-taking/finish'
    | '/_auth/game-session/$gameSessionId/score-taking/presenter'
    | '/_auth/game-session/$gameSessionId/score-taking/session-actions'
    | '/_auth/game-session/$gameSessionId/score-taking/tiebreak-win'
    | '/_auth/friends/teams/$teamId/'
    | '/_auth/game-session/$gameSessionId/score-taking/'
    | '/_auth/game-session/$gameSessionId/score-taking/games/create'
    | '/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete'
    | '/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  AccessDeniedRoute: typeof AccessDeniedRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SetPasswordTokenRoute: typeof SetPasswordTokenRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  AccessDeniedRoute: AccessDeniedRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SetPasswordTokenRoute: SetPasswordTokenRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_auth",
        "/access-denied",
        "/login",
        "/logout",
        "/register",
        "/reset-password",
        "/set-password/$token"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/dev",
        "/_auth/friends/add",
        "/_auth/friends/claim",
        "/_auth/game-session/create",
        "/_auth/dashboard/",
        "/_auth/friends/",
        "/_auth/game-session/",
        "/_auth/game-sessions/",
        "/_auth/records/",
        "/_auth/statistics/",
        "/_auth/dashboard/user-settings/avatar",
        "/_auth/dashboard/user-settings/details",
        "/_auth/friends/$playerId/statistics",
        "/_auth/friends/teams/create",
        "/_auth/records/$playerId/statistics",
        "/_auth/dashboard/user-settings/",
        "/_auth/game-session/$gameSessionId/",
        "/_auth/friends/teams/$teamId/edit",
        "/_auth/game-session/$gameSessionId/score-taking/finish",
        "/_auth/game-session/$gameSessionId/score-taking/presenter",
        "/_auth/game-session/$gameSessionId/score-taking/session-actions",
        "/_auth/game-session/$gameSessionId/score-taking/tiebreak-win",
        "/_auth/friends/teams/$teamId/",
        "/_auth/game-session/$gameSessionId/score-taking/",
        "/_auth/game-session/$gameSessionId/score-taking/games/create",
        "/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete",
        "/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/"
      ]
    },
    "/access-denied": {
      "filePath": "access-denied.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/logout": {
      "filePath": "logout.tsx"
    },
    "/register": {
      "filePath": "register.tsx"
    },
    "/reset-password": {
      "filePath": "reset-password.tsx"
    },
    "/_auth/dev": {
      "filePath": "_auth/dev.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/dev/buttons",
        "/_auth/dev/presenter-configurator",
        "/_auth/dev/",
        "/_auth/dev/presenter/preview",
        "/_auth/dev/score-taking/preview",
        "/_auth/dev/stats/preview",
        "/_auth/dev/presenter/",
        "/_auth/dev/score-taking/",
        "/_auth/dev/stats/"
      ]
    },
    "/set-password/$token": {
      "filePath": "set-password.$token.tsx"
    },
    "/_auth/dev/buttons": {
      "filePath": "_auth/dev/buttons.tsx",
      "parent": "/_auth/dev"
    },
    "/_auth/dev/presenter-configurator": {
      "filePath": "_auth/dev/presenter-configurator.tsx",
      "parent": "/_auth/dev"
    },
    "/_auth/friends/add": {
      "filePath": "_auth/friends/add.tsx",
      "parent": "/_auth"
    },
    "/_auth/friends/claim": {
      "filePath": "_auth/friends/claim.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-session/create": {
      "filePath": "_auth/game-session/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/dashboard/": {
      "filePath": "_auth/dashboard/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/dev/": {
      "filePath": "_auth/dev/index.tsx",
      "parent": "/_auth/dev"
    },
    "/_auth/friends/": {
      "filePath": "_auth/friends/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-session/": {
      "filePath": "_auth/game-session/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-sessions/": {
      "filePath": "_auth/game-sessions/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/records/": {
      "filePath": "_auth/records/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/statistics/": {
      "filePath": "_auth/statistics/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/dashboard/user-settings/avatar": {
      "filePath": "_auth/dashboard/user-settings/avatar.tsx",
      "parent": "/_auth"
    },
    "/_auth/dashboard/user-settings/details": {
      "filePath": "_auth/dashboard/user-settings/details.tsx",
      "parent": "/_auth"
    },
    "/_auth/dev/presenter/preview": {
      "filePath": "_auth/dev/presenter/preview.tsx",
      "parent": "/_auth/dev"
    },
    "/_auth/dev/score-taking/preview": {
      "filePath": "_auth/dev/score-taking/preview.tsx",
      "parent": "/_auth/dev"
    },
    "/_auth/dev/stats/preview": {
      "filePath": "_auth/dev/stats/preview.tsx",
      "parent": "/_auth/dev"
    },
    "/_auth/friends/$playerId/statistics": {
      "filePath": "_auth/friends/$playerId/statistics.tsx",
      "parent": "/_auth"
    },
    "/_auth/friends/teams/create": {
      "filePath": "_auth/friends/teams/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/records/$playerId/statistics": {
      "filePath": "_auth/records/$playerId/statistics.tsx",
      "parent": "/_auth"
    },
    "/_auth/dashboard/user-settings/": {
      "filePath": "_auth/dashboard/user-settings/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/dev/presenter/": {
      "filePath": "_auth/dev/presenter/index.tsx",
      "parent": "/_auth/dev"
    },
    "/_auth/dev/score-taking/": {
      "filePath": "_auth/dev/score-taking/index.tsx",
      "parent": "/_auth/dev"
    },
    "/_auth/dev/stats/": {
      "filePath": "_auth/dev/stats/index.tsx",
      "parent": "/_auth/dev"
    },
    "/_auth/game-session/$gameSessionId/": {
      "filePath": "_auth/game-session/$gameSessionId/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/friends/teams/$teamId/edit": {
      "filePath": "_auth/friends/teams/$teamId/edit.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-session/$gameSessionId/score-taking/finish": {
      "filePath": "_auth/game-session/$gameSessionId/score-taking/finish.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-session/$gameSessionId/score-taking/presenter": {
      "filePath": "_auth/game-session/$gameSessionId/score-taking/presenter.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-session/$gameSessionId/score-taking/session-actions": {
      "filePath": "_auth/game-session/$gameSessionId/score-taking/session-actions.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-session/$gameSessionId/score-taking/tiebreak-win": {
      "filePath": "_auth/game-session/$gameSessionId/score-taking/tiebreak-win.tsx",
      "parent": "/_auth"
    },
    "/_auth/friends/teams/$teamId/": {
      "filePath": "_auth/friends/teams/$teamId/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-session/$gameSessionId/score-taking/": {
      "filePath": "_auth/game-session/$gameSessionId/score-taking/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-session/$gameSessionId/score-taking/games/create": {
      "filePath": "_auth/game-session/$gameSessionId/score-taking/games/create.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete": {
      "filePath": "_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/delete.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/": {
      "filePath": "_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/index.tsx",
      "parent": "/_auth"
    }
  }
}
ROUTE_MANIFEST_END */
